import 'alpinejs';

/**
 * AXIOS
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');


/**
 * LazyLoad
 */
window.Lazyload = require('vanilla-lazyload');
window.umLazyload = new window.Lazyload({
    elements_selector:  '.um-lazyload',
    class_loading:      'um-lazyload--loading',
    class_loaded:       'um-lazyload--loaded',
    class_error:        'um-lazyload--error',
    threshold:          150
});